// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "446e401715feb4931c471430526aa937aefc28ad",
  version: "1.123.2",
};
